import { PARTICIPANT_STATUSES } from './participantStatuses';

export {
  PARTICIPANT_STATUSES,
  PARTICIPANT_STATUS_FILTER_OPTIONS,
  PARTICIPANT_STATUS_BADGE_STYLES,
  PROJECT_PARTICIPANT_STATUSES,
  mapParticipantStatusMeta,
  normalizeParticipantStatusKey,
  mapParticipantStatusBadge,
} from './participantStatuses';

export const PROFILE_IMAGE = '/participants-profile.png';
export const PROFILE_AVATAR = '/participants-avatar.png';

export const SEGMENT_TAGS = {
  recentlyInterviewed: { label: 'Recently Interviewed', color: '#C53030' },
  pendingFeedback: { label: 'Pending Feedback', color: '#C53030' },
  inactiveUser: { label: 'Inactive User', color: '#C53030' },
  recentlyReEngaged: { label: 'Recently Re-Engaged', color: '#C53030' },
  trialUser: { label: 'Trial User', color: '#C53030' },
  churnRiskUsers: { label: 'Churn Risk Users', color: '#33B273' },
  smbAdmins: { label: 'SMB Admins', color: '#7D44DB' },
  powerUsers: { label: 'Power Users', color: '#EF6C00' },
  activeUser: { label: 'Active User', color: '#D69E2E' },
  atRiskUsers: { label: 'At Risk Users', color: '#2F855A' },
  potentialAdvocates: { label: 'Potential Advocates', color: '#2F855A' },
  loyalCustomers: { label: 'Loyal Customers', color: '#3182CE' },
  newUsers: { label: 'New Users', color: '#2F855A' },
};

export const SEGMENT_OPTIONS = Object.values(SEGMENT_TAGS).map((tag) => ({
  label: tag.label,
  value: tag.label,
  color: tag.color,
}));

export const MOCK_SEGMENTS = [
  {
    id: 'power-users',
    label: SEGMENT_TAGS.powerUsers.label,
    color: SEGMENT_TAGS.powerUsers.color,
    participantCount: 12,
    participantIds: ['1', '2', '3', '4'],
  },
  {
    id: 'recently-interviewed',
    label: SEGMENT_TAGS.recentlyInterviewed.label,
    color: SEGMENT_TAGS.recentlyInterviewed.color,
    participantCount: 12,
    participantIds: ['1', '2', '5'],
  },
  {
    id: 'smb-admins',
    label: SEGMENT_TAGS.smbAdmins.label,
    color: SEGMENT_TAGS.smbAdmins.color,
    participantCount: 12,
    participantIds: ['1', '3', '4'],
  },
];

const CONSENT_AGREED = {
  name: 'Consent form.doc',
  timestamp: '1 Jun 2026, 4:12 PM',
  agreed: true,
  detail: 'to Voluntary participation, can withdraw anytime',
};

const CONSENT_NOT_AGREED = {
  name: 'Consent form.doc',
  timestamp: '1 Jun 2026, 4:12 PM',
  agreed: false,
  detail: 'to being quoted publicly by name',
};

const SAMPLE_NOTE = {
  text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna.',
  addedBy: 'you',
  date: 'Jun 10, 2026',
};

export const MOCK_PARTICIPANTS = [
  {
    id: '1',
    projectStatus: PARTICIPANT_STATUSES.invited,
    participant: { name: 'Kritika Oberoi', email: 'kritikaoberoi@gmail.com', avatar: PROFILE_AVATAR },
    email: 'kritikaoberoi@gmail.com',
    company: 'Freshboost',
    location: 'United States',
    status: { label: 'Eligible', color: '#2C7A7B', background: '#E6FFFA' },
    linkedProjects: 4,
    invitedProjects: 5,
    completedProjects: 1,
    lastInterviewed: '2 days ago',
    incentivePaid: '0',
    contactFrequency: 'Day',
    joinedDate: 'June 1 2026',
    segments: [
      SEGMENT_TAGS.powerUsers,
      SEGMENT_TAGS.recentlyInterviewed,
      SEGMENT_TAGS.smbAdmins,
      SEGMENT_TAGS.churnRiskUsers,
    ],
    consent: [
      { id: 'c1', ...CONSENT_AGREED },
    ],
    notes: [
      { id: 'n1', ...SAMPLE_NOTE },
    ],
  },
  {
    id: '2',
    projectStatus: PARTICIPANT_STATUSES.screener_invited,
    participant: { name: 'Aditya Mehra', email: 'adityamehra@gmail.com', avatar: PROFILE_IMAGE },
    email: 'adityamehra@gmail.com',
    company: 'Loopstack',
    location: 'India',
    status: { label: 'Eligible', color: '#2C7A7B', background: '#E6FFFA' },
    linkedProjects: 4,
    invitedProjects: 5,
    completedProjects: 3,
    lastInterviewed: '1 week ago',
    incentivePaid: '200 USD',
    contactFrequency: 'As needed',
    joinedDate: 'June 3 2024',
    segments: [
      SEGMENT_TAGS.recentlyInterviewed,
      SEGMENT_TAGS.churnRiskUsers,
      SEGMENT_TAGS.activeUser,
      SEGMENT_TAGS.loyalCustomers,
    ],
    consent: [{ id: 'c1', ...CONSENT_AGREED }],
    notes: [
      { id: 'n1', text: 'Participant notes will appear here.', addedBy: 'you', date: 'Jun 10, 2026' },
    ],
  },
  {
    id: '3',
    projectStatus: PARTICIPANT_STATUSES.qualified,
    participant: { name: 'Priya Sharma', email: 'priyasharma@gmail.com', avatar: PROFILE_IMAGE },
    email: 'priyasharma@gmail.com',
    company: 'Designly',
    location: 'United Kingdom',
    status: { label: 'Invited', color: '#D69E2E', background: '#FEF3C7' },
    linkedProjects: 2,
    invitedProjects: 3,
    completedProjects: 1,
    lastInterviewed: '3 days ago',
    incentivePaid: '150 USD',
    contactFrequency: '3 days',
    joinedDate: 'May 12 2025',
    segments: [
      SEGMENT_TAGS.pendingFeedback,
      SEGMENT_TAGS.atRiskUsers,
      SEGMENT_TAGS.newUsers,
    ],
    consent: [],
    notes: [],
  },
  {
    id: '4',
    projectStatus: PARTICIPANT_STATUSES.completed,
    participant: { name: 'Rahul Verma', email: 'rahulverma@gmail.com', avatar: PROFILE_IMAGE },
    email: 'rahulverma@gmail.com',
    company: 'Acme Corp',
    location: 'Canada',
    status: { label: 'Eligible', color: '#2C7A7B', background: '#E6FFFA' },
    linkedProjects: 6,
    invitedProjects: 8,
    completedProjects: 5,
    lastInterviewed: '5 days ago',
    incentivePaid: '250 USD',
    contactFrequency: 'Month',
    joinedDate: 'April 8 2025',
    segments: [
      SEGMENT_TAGS.powerUsers,
      SEGMENT_TAGS.potentialAdvocates,
      SEGMENT_TAGS.smbAdmins,
    ],
    consent: [{ id: 'c1', ...CONSENT_AGREED }],
    notes: [
      { id: 'n1', text: 'Follow up on next project invite.', addedBy: 'you', date: 'Jun 10, 2026' },
    ],
  },
  {
    id: '5',
    projectStatus: PARTICIPANT_STATUSES.completed,
    participant: { name: 'Ananya Patel', email: 'ananyapatel@gmail.com', avatar: PROFILE_IMAGE },
    email: 'ananyapatel@gmail.com',
    company: 'Brightpath',
    location: 'United States',
    status: { label: 'Eligible', color: '#2C7A7B', background: '#E6FFFA' },
    linkedProjects: 3,
    invitedProjects: 4,
    completedProjects: 2,
    lastInterviewed: '1 day ago',
    incentivePaid: '200 USD',
    contactFrequency: 'Day',
    joinedDate: 'March 15 2026',
    segments: [
      SEGMENT_TAGS.recentlyReEngaged,
      SEGMENT_TAGS.activeUser,
      SEGMENT_TAGS.trialUser,
    ],
    consent: [],
    notes: [],
  },
  {
    id: '6',
    projectStatus: PARTICIPANT_STATUSES.completed,
    participant: { name: 'Vikram Singh', email: 'vikramsingh@gmail.com', avatar: PROFILE_IMAGE },
    email: 'vikramsingh@gmail.com',
    company: 'Northwind',
    location: 'Australia',
    status: { label: 'Inactive', color: '#C53030', background: '#FED7D7' },
    linkedProjects: 1,
    invitedProjects: 2,
    completedProjects: 1,
    lastInterviewed: '2 weeks ago',
    incentivePaid: '100 USD',
    contactFrequency: 'Year',
    joinedDate: 'February 20 2024',
    segments: [
      SEGMENT_TAGS.inactiveUser,
      SEGMENT_TAGS.churnRiskUsers,
    ],
    consent: [],
    notes: [],
  },
  {
    id: '7',
    projectStatus: PARTICIPANT_STATUSES.qualified,
    participant: { name: 'Sneha Reddy', email: 'snehareddy@gmail.com', avatar: PROFILE_IMAGE },
    email: 'snehareddy@gmail.com',
    company: 'Cloudbase',
    location: 'Singapore',
    status: { label: 'Eligible', color: '#2C7A7B', background: '#E6FFFA' },
    linkedProjects: 5,
    invitedProjects: 6,
    completedProjects: 4,
    lastInterviewed: '4 days ago',
    incentivePaid: '200 USD',
    contactFrequency: 'As needed',
    joinedDate: 'January 10 2025',
    segments: [
      SEGMENT_TAGS.loyalCustomers,
      SEGMENT_TAGS.potentialAdvocates,
      SEGMENT_TAGS.newUsers,
    ],
    consent: [{ id: 'c1', ...CONSENT_AGREED }],
    notes: [
      { id: 'n1', text: 'Strong advocate for product feedback sessions.', addedBy: 'you', date: 'Jun 10, 2026' },
    ],
  },
  {
    id: '8',
    projectStatus: PARTICIPANT_STATUSES.screener_invited,
    participant: { name: 'Arjun Nair', email: 'arjunnair@gmail.com', avatar: PROFILE_IMAGE },
    email: 'arjunnair@gmail.com',
    company: 'Pixelworks',
    location: 'India',
    status: { label: 'Eligible', color: '#2C7A7B', background: '#E6FFFA' },
    linkedProjects: 3,
    invitedProjects: 3,
    completedProjects: 2,
    lastInterviewed: '6 days ago',
    incentivePaid: '175 USD',
    contactFrequency: 'Month',
    joinedDate: 'December 5 2025',
    segments: [
      SEGMENT_TAGS.recentlyInterviewed,
      SEGMENT_TAGS.atRiskUsers,
      SEGMENT_TAGS.powerUsers,
    ],
    consent: [],
    notes: [],
  },
  {
    id: '9',
    projectStatus: PARTICIPANT_STATUSES.invited,
    participant: { name: 'Meera Iyer', email: 'meeraiyer@gmail.com', avatar: PROFILE_IMAGE },
    email: 'meeraiyer@gmail.com',
    company: 'Studio Nine',
    location: 'United States',
    status: { label: 'Responded', color: '#805AD5', background: '#EDE9FE' },
    linkedProjects: 2,
    invitedProjects: 2,
    completedProjects: 1,
    lastInterviewed: '3 weeks ago',
    incentivePaid: '150 USD',
    contactFrequency: '3 days',
    joinedDate: 'November 18 2024',
    segments: [
      SEGMENT_TAGS.pendingFeedback,
      SEGMENT_TAGS.smbAdmins,
    ],
    consent: [],
    notes: [],
  },
  {
    id: '10',
    projectStatus: PARTICIPANT_STATUSES.completed,
    participant: { name: 'Karan Malhotra', email: 'karanmalhotra@gmail.com', avatar: PROFILE_IMAGE },
    email: 'karanmalhotra@gmail.com',
    company: 'Venture Labs',
    location: 'United Arab Emirates',
    status: { label: 'Eligible', color: '#2C7A7B', background: '#E6FFFA' },
    linkedProjects: 7,
    invitedProjects: 9,
    completedProjects: 6,
    lastInterviewed: 'Yesterday',
    incentivePaid: '300 USD',
    contactFrequency: 'Day',
    joinedDate: 'October 2 2025',
    segments: [
      SEGMENT_TAGS.activeUser,
      SEGMENT_TAGS.loyalCustomers,
      SEGMENT_TAGS.potentialAdvocates,
      SEGMENT_TAGS.newUsers,
    ],
    consent: [{ id: 'c1', ...CONSENT_AGREED }],
    notes: [
      { id: 'n1', text: 'High engagement participant.', addedBy: 'you', date: 'Jun 10, 2026' },
    ],
  },
];

export function getParticipantById(id) {
  if (!id) return null;

  const found = MOCK_PARTICIPANTS.find((participant) => participant.id === id);
  if (found) return found;

  // Detail API is not wired yet — fall back to mock content using the route id
  // so row clicks from the live list still open the detail layout.
  if (!MOCK_PARTICIPANTS.length) return null;

  let hash = 0;
  for (let i = 0; i < id.length; i += 1) {
    hash = (hash + id.charCodeAt(i)) % MOCK_PARTICIPANTS.length;
  }

  const fallback = MOCK_PARTICIPANTS[hash];
  return {
    ...fallback,
    id,
    participant: { ...fallback.participant },
    segments: [...(fallback.segments || [])],
    consent: [...(fallback.consent || [])],
    notes: [...(fallback.notes || [])],
  };
}
